Vue.component('currentBattle', {
  template: templates.currentBattle,
  data() {
    return {
      model: {
        battle: [],
        hasResults: false,
        isLoading: false
      },
      cancelTokenSource: null
    }
  },
  mounted() {
    const c = this;
    c.connect();
    c.get(false);

  },
  beforeDestroy() {
    const c= this;
    
    if (c.ws) {
      c.ws.close();
    }

    if (c.cancelTokenSource) {
      c.cancelTokenSource.cancel('Request canceled due to component destruction.');
    }
  },
  computed: {
    team1DisplayNames() {
        return this.model.battle.team1.map(member => member.user[0].twitchDisplayName).join(', ');
    },
    team2DisplayNames() {
        return this.model.battle.team2.map(member => member.user[0].twitchDisplayName).join(', ');
    },
  },
  methods: {
    connect() {
      const c = this;
      c.ws = new WebSocket(utils.getWsUrl());

      c.ws.onmessage = (event) => {
         const messageData = event.data;
         try {
          const parsedData = JSON.parse(messageData);
          
          if( 
            (parsedData.message === 'battle_canceled' || 
            parsedData.message === 'requeue_battle' || 
            parsedData.message === 'team_requeue_battle' || 
            parsedData === 'team_battle_canceled' ||  
            parsedData.message === 'streamer_team_battle_started' || 
            parsedData.message === 'streamer_team_battle_requeued' || 
            parsedData.message === 'battle_started' || 
            parsedData.message === 'team_battle_started') && 
            parsedData.channelId === utils.cookies.get('channelId')
          ){
            c.get(true);
          }
        }catch (error) {
          console.error('Error parsing message data:', error);
        }
      };

      c.ws.onopen = () => {
        console.log('WebSocket connection established');
      };

      c.ws.onclose = () => {
        console.log('WebSocket connection closed');
      };
    },
    get(isWebsocket) {
      const c = this;
      battleService.getActive()
        .then(function (response) {
          console.log(response)
       
          let data = response.data[0];
          
          if(!data){
            return;
          }
          if(data.mode === 'single'){
            if (data.twitch1DisplayName == null || data.twitch2DisplayName == null) {
              // c.getTwitchName(data);
            
            } else {
              data.user1TwitchDisplayName = data.twitch1DisplayName;
              data.user2TwitchDisplayName = data.twitch2DisplayName;
              if(isWebsocket){
             
              }

              c.model.battle = data
           
              c.model.hasResults = true;
            }
          }
          else{
            c.model.hasResults = true;
            c.model.battle = data
          }

          c.model.isLoading = true;
         
          // setTimeout(function() {
          //   c.get();
          // }, 5000);
        })
        .catch(function (error) {
          c.model.hasResults = false;
          c.model.battle = []
          // setTimeout(function() {
          //   c.model.isLoading = true;
          //   c.get();
          // }, 10000);
          
        });
    }, 
    getTwitchName(data) {
      const c = this;
      let url = `${apiUrl}users?`;
      for (let i in data) {
        url = `${url}id=${data.user1TwitchId}&id=${data.user2TwitchId}&`;
      }

      axios.get(url, {
          headers: { 
            'Client-ID': clientId,
            'Authorization': `Bearer ${utils.cookies.get('access_token')}` 
          }
        })
        .then(function (response) {
          for (let d of response.data.data) {
            if (data.user1TwitchId == d.id) {
              data.user1TwitchDisplayName = d.display_name;
            } else if (data.user2TwitchId == d.id) {
              data.user2TwitchDisplayName = d.display_name;
            }
          }
          c.model.battle = data
          c.model.hasResults = true;
        })
        .catch(function (error) {
          if (error.response.status == 401) {
            authentication.refreshAccessToken({callback: function() {
              c.getTwitchName(data);
            }});
          }
        });
    },
    queue(data, isSingle) {
      const c = this;

      var result = confirm("Are you sure you want to requeue this battle?");
      if (result == true) {
        if(isSingle){
     
           battleService.requeue({id: data})
          .then(function (response) {

            c.ws.send(JSON.stringify(messageData));


            c.model.hasResults = false;
            c.model.battle = [];


            c.get()
            

          })
          .catch(function (error) {
            //console.log(error);
          });
        }
        else{
           teamBattleService.requeue({id: data})
          .then(function (response) {
          let messageData;
            if(data.streamerBattle){
              messageData = {
                  message: 'streamer_team_battle_requeued',
                  channelId: utils.cookies.get('channelId'),
                  username1: data.streamerAccept[0].twitchDisplayName,
                  username2: data.streamerChallenge[0].twitchDisplayName,
              };
            }
            else{
              messageData = {
                  message: 'team_requeue_battle',
                  channelId: utils.cookies.get('channelId'),
                  username1: c.getPlayerDisplayNames(data, 1),
                  username2: c.getPlayerDisplayNames(data, 2) 
              };
            }
          

            c.ws.send(JSON.stringify(messageData));

            
            c.model.hasResults = false;
            c.model.battle = null;

          })
          .catch(function (error) {
            //console.log(error);
          });
        }
       
      }
    },
     getPlayerDisplayNames(battle, player){
      const c = this;
      if(player === 1){
         return battle.team1.map(member => member.user[0].twitchDisplayName).join(', ')
      }
      else{
        return battle.team2.map(member => member.user[0].twitchDisplayName).join(', ')
      }


    },
    cancel(data, isSingle) {
      const c = this;

      var result = confirm("Are you sure you want to stop this battle?");
      if (result == true) {
        
        if(isSingle){
          battleService.cancel({id: data})
            .then(function (response) {

              const messageData = {
                message: 'battle_canceled',
                channelId: utils.cookies.get('channelId'),
                username1: c.model.battle.user1TwitchDisplayName[0].twitchDisplayName,
                username2: c.model.battle.user2TwitchDisplayName[0].twitchDisplayName,
              };

              c.ws.send(JSON.stringify(messageData));


              c.model.hasResults = false;
              c.model.battle = [];
              
              c.get();

           
            })
            .catch(function (error) {
              console.log(error);
            });
          }
        else{

           teamBattleService.cancel({id: data})
            .then(function (response) {
              const messageData = {
                message: 'team_battle_cancelled',
                channelId: utils.cookies.get('channelId'),
                username1: c.getPlayerDisplayNames(data, 1),
                username2: c.getPlayerDisplayNames(data, 2) 
              };

              c.ws.send(JSON.stringify(messageData));
            })
            .catch(function (error) {
              //console.log(error);
            });
        }
        
      }
    }
  }
});